import React, { useCallback, useState } from 'react'
import dynamic from 'next/dynamic'

import Switch from 'shared/ui/Switch'

import styles from './CustomerConsentSwitch.module.scss'

const ConfirmationModal = dynamic(
  () => import('shared/ui/ConfirmationModal')
)

interface CustomerConsentSwitchProps {
  checked: boolean
  onConsentChange: (value: boolean) => void
  label: string
  switchId: string
  modalId: string
  modalTitle: string
  modalDescription: string
  confirmTestId?: string
  cancelTestId?: string
}

const CustomerConsentSwitch = ({
  checked,
  onConsentChange,
  label,
  switchId,
  modalId,
  modalTitle,
  modalDescription,
  confirmTestId,
  cancelTestId
}: CustomerConsentSwitchProps) => {
  const [open, setOpen] = useState(false)

  const handleConfirm = () => {
    onConsentChange(false)
    setOpen(false)
  }

  const handleChange = useCallback(
    (event: React.ChangeEvent<HTMLInputElement>) => {
      const value = event.target.checked

      if (!value) {
        setOpen(true)
      } else {
        onConsentChange(value)
      }
    },
    [onConsentChange]
  )

  return (
    <div className={styles.wrapper}>
      <div className={styles.label}>{label}</div>
      <Switch
        id={switchId}
        variant='primary'
        checked={checked}
        onChange={handleChange}
        ariaLabel={label}
      />
      {open && (
        <ConfirmationModal
          id={modalId}
          title={modalTitle}
          description={modalDescription}
          open={open}
          onClose={() => setOpen(false)}
          onConfirm={handleConfirm}
          confirmTestId={confirmTestId}
          cancelTestId={cancelTestId}
        />
      )}
    </div>
  )
}

export default CustomerConsentSwitch
